var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReputation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.27 26.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.25,7.75a28.85,28.85,0,0,0-8.77-3.59h0A24.71,24.71,0,0,0,9.84,6.1a3,3,0,0,1,.51,1.14,25.79,25.79,0,0,1,5.12-1.81h0v18c-3.4-.85-5.28-3.75-6.3-6.84a2.3,2.3,0,0,1-.73.56l0,1c1.24,3.06,3.39,5.81,7.07,6.6h0c9.45-2,8.77-17,8.77-17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.48,4.62a1.48,1.48,0,0,0,1.1.57,1.47,1.47,0,0,0,1.09-.57,3.17,3.17,0,0,0,.56-1.18c.68-.68.38-1.08.38-1.08s-.09,0-.15,0a2.06,2.06,0,0,0,.06-.6c0-1.36-1-1.4-1-1.4A1.61,1.61,0,0,0,4.3,0,1.64,1.64,0,0,0,2.63,1.64a6.82,6.82,0,0,0,.1.72.1.1,0,0,0-.16,0s-.28.38.34,1a3.36,3.36,0,0,0,.57,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.18,8.14V8A1.64,1.64,0,0,0,8.6,6.6a9.19,9.19,0,0,0-2.89-1,7.66,7.66,0,0,1-.55,1.68,3.48,3.48,0,0,1-.58.92A5.56,5.56,0,0,1,4,7.26,6.61,6.61,0,0,1,3.4,5.6a8.84,8.84,0,0,0-2.81,1A1.63,1.63,0,0,0,0,8v.19l.71,7.09a.92.92,0,0,0,.88.88h.35l.58,10.83H6.66l.58-10.83H7.6a1,1,0,0,0,.88-.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputation);
export default __webpack_public_path__ + "static/media/REPUTATION.52ac958e.svg";
export { ForwardRef as ReactComponent };